import { z } from 'zod';

const packageRowSchema = z.object({
  qty: z.coerce.number({
    required_error: '請輸入數量',
    invalid_type_error: '數量必須為數字',
  })
    .int('數量必須為整數')
    .min(1, '數量必須大於 0'),
  locationId: z.string().optional().nullable(),
});

export const workOrderInboundFormSchema = z.object({
  receiptDate: z.string().min(1, '請填寫單據日'),
  warehouseId: z.string().min(1, '請選擇入庫倉'),
  unitId: z.string().min(1, '請選擇單位'),
  unitPrice: z.coerce.number({
    required_error: '請輸入單價',
    invalid_type_error: '單價必須為數字',
  }).min(0, '單價不可為負'),
  materialRemark: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  issueReason: z.string().optional().nullable(),
  packages: z.array(packageRowSchema).min(1, '請至少新增一筆包裝'),
});

export const WORK_ORDER_INBOUND_FIELD_LABELS = {
  receiptDate: '單據日',
  warehouseId: '入庫倉',
  unitId: '單位',
  unitPrice: '單價',
  materialRemark: '物料備註',
  remark: '備註',
  issueReason: '入庫事由',
  packages: '包裝',
  'packages.qty': '數量',
  'packages.locationId': '儲位',
};

/** 包裝列僅 qty／location；單位在表單根層 unitId（繼承至 packages）。 */
export const DEFAULT_INBOUND_PACKAGE = {
  qty: '',
  locationId: '',
};

export const DEFAULT_INBOUND_FORM_VALUES = {
  receiptDate: '',
  warehouseId: '',
  unitId: '',
  unitPrice: '',
  materialRemark: '',
  remark: '',
  issueReason: '',
  packages: [{ ...DEFAULT_INBOUND_PACKAGE }],
};

export function buildInboundDefaultValues(detail) {
  return {
    ...DEFAULT_INBOUND_FORM_VALUES,
    warehouseId: detail?.targetWarehouse?.id
      ?? detail?.targetWarehouseId
      ?? '',
    packages: [{ ...DEFAULT_INBOUND_PACKAGE }],
  };
}
